(() => {
  if (!customElements.get('nbb-card-scroll')) {
    class ColourCardScroll extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.busy = false;
        this.link.hidden = true;
        this.addEventListener('click', event => {
          if (event.target.closest('a')) {
            event.preventDefault();
            this.loadNext();
          }
        });
        this.prefetchObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.fetchNext();
        }, { rootMargin: `${Math.max(window.innerHeight * 2, 1200)}px 0px` });
        this.prefetchObserver.observe(this);
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadNext();
        }, { rootMargin: `${Math.round(window.innerHeight / 2)}px 0px` });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.prefetchObserver?.disconnect();
        this.request?.abort();
        clearTimeout(this.timeout);
      }

      showRetry() {
        this.busy = false;
        this.link.hidden = false;
        this.removeAttribute('aria-busy');
        this.querySelector('[data-infinite-scroll]')?.classList.add('hidden');
        this.observer?.disconnect();
        this.prefetchObserver?.disconnect();
      }

      fetchNext() {
        if (!this.isConnected) return Promise.resolve(null);
        if (this.pending) return this.pending;
        this.request = new AbortController();
        this.timeout = setTimeout(() => this.request.abort(), 12000);
        const url = new URL(this.link.href);
        url.searchParams.set('section_id', this.dataset.cardEndpoint || this.dataset.sectionId);
        this.pending = fetch(url, { signal: this.request.signal })
          .then(async response => {
            if (!response.ok) throw new Error('Collection request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (!doc.querySelector('[main-collection-products] [data-product-card]')) throw new Error('Collection cards missing');
            return doc;
          })
          .catch(() => {
            this.pending = null;
            if (this.isConnected) this.showRetry();
            return null;
          })
          .finally(() => clearTimeout(this.timeout));
        return this.pending;
      }

      async loadNext() {
        if (this.busy || !this.isConnected) return;
        const grid = this.closest('[data-colour-card-pagination]');
        const cards = grid?.querySelector('[main-collection-products]');
        if (!cards) return;
        this.busy = true;
        this.link.hidden = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-infinite-scroll]')?.classList.remove('hidden');
        try {
          const doc = await this.fetchNext();
          if (!doc) return;
          const nextGrid = doc.querySelector('[data-colour-card-pagination]');
          const incoming = nextGrid?.querySelector('[main-collection-products]');
          if (!incoming || !incoming.querySelector('[data-product-card]')) throw new Error('Collection cards missing');
          if (!this.isConnected || !cards.isConnected) return;
          const fragment = document.createDocumentFragment();
          for (const child of Array.from(incoming.children)) fragment.append(child);
          cards.append(fragment);
          grid.dataset.cardTotal = nextGrid.dataset.cardTotal;
          const count = grid.closest('section')?.querySelector('[data-total-products-count]');
          if (count) count.textContent = `${cards.querySelectorAll('[data-product-card]').length}/${grid.dataset.cardTotal}`;
          const next = nextGrid.querySelector('nbb-card-scroll');
          if (next) this.replaceWith(next);
          else this.remove();
          window.ScrollTrigger?.refresh();
        } catch (error) {
          if (this.isConnected) this.showRetry();
        }
      }
    }
    customElements.define('nbb-card-scroll', ColourCardScroll);
  }

  customElements.whenDefined('filter-faced-form').then(() => {
    const FilterForm = customElements.get('filter-faced-form');
    if (FilterForm.nbbColourCardsPatched) return;
    const renderPage = FilterForm.renderPage;
    FilterForm.renderPage = function (query, ...rest) {
      if (document.querySelector('[data-colour-card-pagination]')) {
        const params = new URLSearchParams(query);
        const view = document.querySelector('[data-colour-card-pagination]').dataset.templateSuffix;
        if (view) params.set('view', view);
        else params.delete('view');
        params.delete('page');
        query = params.toString();
      }
      return renderPage.call(this, query, ...rest);
    };
    FilterForm.nbbColourCardsPatched = true;
  });
})();
